import { StorageClient } from '@juvare/platform-sdk-js/StorageClient';
import { jurisdictionEntityName } from '@juvare/platform-sdk-react/backend/features/default-classifiers/shared';
export const valueProviders = [
    {
        type: 'availableMissionLocationStates',
        label: 'Available Mission Location States',
        getValues: () => {
            const settingStorage = new StorageClient('setting');
            const jurisdictionStorage = new StorageClient(jurisdictionEntityName);
            return settingStorage
                .list({
                filter: [
                    {
                        column: 'name',
                        op: '=',
                        value: 'availableMissionLocationStates',
                    },
                ],
            })
                .then((results) => {
                const [availableMissionLocationStates] = results.rows;
                const { availableStates } = JSON.parse(availableMissionLocationStates.columns.value);
                return jurisdictionStorage
                    .list({
                    filter: [
                        {
                            column: 'postalCode',
                            op: 'in',
                            value: availableStates,
                        },
                    ],
                })
                    .then((statesResponse) => statesResponse.rows.map((state) => ({
                    label: state.columns.name,
                    value: state.columns.postalCode,
                })));
            });
        },
    },
];
